<template>



    <div class="title bg-gradient-primary">
         {{$t('title')}}
    </div>

    <router-view>

    </router-view>

    <div style="margin-bottom: 60px;"></div>

    <footer class="bg-gradient-primary footer">
        Copyright © 2024 Motinova All rights reserved.
    </footer>




</template>

<script>
export default {
    data() {
        return {}
    },
    methods: {
        open(router) {
            this.$router.push(router);
        }
    }

}
</script>

<style>
.footer {
    height: 60px;
    line-height: 60px;
    font-size: 10px;
    color: aliceblue;
    font-weight: bold;

    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
}


.title {
    height: 60px;
    line-height: 60px;
    font-size: 16px;
    color: aliceblue;
    font-weight: bold;
}
</style>